import Template from './ModifyAnnotationSidebarView.hbs';
import Button from 'views/components/button/Button.svelte'
import Input from 'views/components/annotations/input/Input'

export default class ModifyAnnotationsSidebarView extends BaseView {

    initialize() {

        _.bindAll(this,
            'onRemoveAnnotation',
            'removeAnnotation',
        );

        this.setElement(Template({}));

        this.annotationInput = this.addChildView(new Input({
            model: this.model,
            groupModel: this.model.getGroupModel(),
            annotationSavedCallback: this.annotationSaved,
        }), '.js-annotation-input-container')

        this.modus = 'edit';

        // only annotation's author can remove it
        if (Backbone.Model.user.get('id') === this.model.get('user_id')) {
            this.addSvelteChildView(
                '.js-remove-annotations',
                Button,
                {
                    label: window.i18n.gettext('Remove annotation'),
                    theme: 'secondary',
                    inline: true,
                    callback: this.onRemoveAnnotation
                }
            );
        }
    }

    onRemoveAnnotation() {
        Backbone.View.layout.openConfirmStatus(
            window.i18n.gettext('Are you sure you want to remove this annotation?'),
            this.removeAnnotation,
            () => {},
            window.i18n.gettext('Remove')
        )
    }

    removeAnnotation() {
        // Check if the rights are correct to remove an annotation
        if (Backbone.Model.user.get('is_teacher') || this.model.get('user_id') === Backbone.Model.user.get('id')) {
            Backbone.View.sidebar.closeSidebar()

            // Remove from collection
            this.model.getGroupModel().annotations.remove(this.model);

            // Delete this model (will call a DELETE)
            this.model.destroy();
        }
    }

    annotationSaved() {
        // Close the sidebar
        Backbone.View.sidebar.closeSidebar();

        // Show a message that the annotation has been saved
        Backbone.View.layout.openStatus(
            window.i18n.gettext('The annotation has been saved succesfully.'),
            'success'
        );
    }

}
